import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/coconut_croissant_3_for_5.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function CoconutCroissant() {
  useMetaTracking("ViewContent", {
    content_name: "Coconut Croissant",
    content_category: "Regular Menu",
    content_ids: ["coconut_croissant"],
    content_type: "pastries",
    value: 2.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Coconut Croissant | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="With a delicate, flaky pastry layered with a luscious coconut filling that infuses each bite with a hint of tropical paradise, this treat offers the perfect balance of crispness and tenderness."
        />
        <meta property="og:title" content="Coconut Croissant | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="A delightful twist on the classic croissant. With a delicate, flaky pastry layered with a luscious coconut filling that infuses each bite with a hint of tropical paradise, this treat offers the perfect balance of crispness and tenderness."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Coconut Croissant"
          titleSubHead="$2.00 each / 3 for $5"
          detailBody="A flaky pastry layered with a luscious coconut filling that infuses each bite with a hint of tropical paradise."
          detailBodyBr="Contains: wheat, dairy, egg, coconut"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default CoconutCroissant;